<div class="image-container">
  <h2>{{ "INFO_POPUP.HOW_TO_USE" | translate }}</h2>
  <img src="./assets/how-to-use/mind.jpeg" alt="mind">
  <p class="left">{{ "INFO_POPUP.LEFT" | translate }}</p>
  <p class="center">{{ "INFO_POPUP.CENTER" | translate }}</p>
  <p class="right">{{ "INFO_POPUP.RIGHT" | translate }}</p>
</div>
